import { InjectionToken } from '@angular/core';

export type RewardsHubConfig = {
  hiddenPromoByName: string[];
}

export const REWARDS_HUB_CONFIG = new InjectionToken<RewardsHubConfig>('REWARDS_HUB_CONFIG');
